<template>
  <div class="contain-inside">
    <QuestionSliderOption 
      :item="item" 
      :editable="true"
      @edit_clicked="edit_clicked"
      @selected="selected_value"
    />
  </div>
</template>

<script>
import QuestionSliderOption from '@/view/components/questions/QuestionSliderOption.vue';

export default {
  name: 'WebBuilderSurveySlider',
  emits: ['edit_clicked','selected'],
  components: {
    QuestionSliderOption,
  },
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data() { 
    return {
      question_asked: {
        id: 1,
        type: 'SLIDER',
        name: 'Hur många gånger har du vandrat?',
        min_value: 1,
        max_value: 100,
        steps: 1,
      },
    }
  },
  methods: {

    edit_clicked(part, data) {
      this.$emit('edit_clicked', part, this.item);
    },
    selected_value(value) {
      this.$emit('selected', this.item, value);
    },
  }
};
</script>
